export class UserLoginDto {
    userName: string;
    password: string;
    secondFactor: string;
    loginChallengeId: string;
    resendSecondFactor = false;
}
